import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink ,useNavigate} from "react-router-dom";
import "../../css/MenuMobile.css";

import { useAuth  } from "../Auth/AuthContext";

const MobileMenu = ({ isOpen, onClose }) => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  return (
    <div
      onClick={onClose}
      className={`mobile-menu fixed top-0 right-0 w-64 h-full bg-white shadow-lg lg:hidden z-50 transition-transform duration-300 ${isOpen ? "show" : ""
        }`}
    >
      <div className="p-4">
        <button
          onClick={onClose}
          className="float-left mb-4 text-gray-700 hover:text-primary transition-colors"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <div className="clear-both space-y-4 mt-8">
          {/* Mobile Menu Search */}
          <div className="relative mb-6">
            <input
              type="text"
              className="w-full p-3 pr-10 border border-gray-200 rounded-xl text-right"
              placeholder="جستجو..."
            />
            <svg
              className="w-4 h-4 absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>

          <NavLink
            to={'/'}
            exact activeClassName="active" className="block text-gray-700 hover:text-primary py-3 font-medium border-b border-gray-100 transition-colors" > خانه
          </NavLink>
           <NavLink
            to={'consultation'}
            exact activeClassName="active"
            className="block text-gray-700 hover:text-primary py-3 font-medium border-b border-gray-100 transition-colors"
          >
            فرم مشاوره
          </NavLink>
          <NavLink
            to={'courses'}
            exact activeClassName="active" className="block text-gray-700 hover:text-primary py-3 font-medium border-b border-gray-100 transition-colors"
          >
            دوره‌ها
          </NavLink>
          <NavLink
            to={'blog'}
            exact activeClassName="active" className="block text-gray-700 hover:text-primary py-3 font-medium border-b border-gray-100 transition-colors"
          >
            مقالات
          </NavLink>
          <NavLink
            to={'about'}
            exact activeClassName="active"
            className="block text-gray-700 hover:text-primary py-3 font-medium border-b border-gray-100 transition-colors"
          >
            درباره ما
          </NavLink>
          <NavLink
            to={'contact'}
            exact activeClassName="active"
            className="block text-gray-700 hover:text-primary py-3 font-medium border-b border-gray-100 transition-colors"
          >
            تماس
          </NavLink>
         

          <div className="pt-4">
            {user ? (
              <>
                {/* Logout Button (Only visible on lg and larger) */}
                <button
                  onClick={handleLogout}
                  className="w-full lg:flex items-center gap-1 px-4 py-2 rounded-full bg-red-100 hover:bg-red-200 text-red-700 transition"
                  title="خروج از حساب کاربری"
                >
                  <i className="fa fa-power-off"></i> خروج
                </button>
              </>
            ) : (
              // Login/Register Button for guests
              <Link to="/login">
                <button className="w-full cta-button text-center">
                  🚀 ورود ثبت نام
                </button>
              </Link>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
